<template>
  <div class="home" v-if="store.render.Homepage">

    <el-row :style="`padding: 30px 0px; color: ${store.theme.viewMode.textColor[store.theme.viewMode.active]}`"
      :gutter="20">
      
      <el-col :xs="{span: 22, offset: 1}" :sm="{span: 22, offset: 1}" :md="{span: 20, offset: 1}" :lg="{span: 16, offset: 5}"
        style="font-size: 1em;" >
        GEAR-19 is a genomic data resource for tracking the dynamic evolution of Indian SARS-CoV-2 virus isolates. Our 
        platform contains data of genomes sequenced from India, related patient metadata and interactive visualizations 
        to aid the user understand the mutation landscape as well as the extent of genomic surveillance in the country.
      </el-col>
    </el-row>

    <side-icons></side-icons>
    <main-statistics></main-statistics>

    <el-row>
      <el-col :sm="{span: 20, offset:1}" :lg="{span: 16, offset:5}"
        style="margin-top: 2em; margin-bottom: 2em;">
        <el-divider/>
      </el-col>
    </el-row>

    <el-row style="margin-bottom: 1em">
      <el-col :xs="{span: 22, offset: 1}" :sm="{span: 22, offset: 1}" :md="{span: 20, offset: 1}" :lg="{span: 16, offset: 5}"
        :gutter="20">
        <!-- <div class="page-header" style="text-align: center">Situation Report</div> -->
        <div :style="`font-size: 1em; color: ${store.theme.viewMode.textColor[store.theme.viewMode.active]}`">
          This page summarises different statistics corresponding to all the sequenced SARS-CoV-2
          genomes in India in the user selected time frame. Basic plots
          show the number of genomes from different states and the patient age and gender demographics. Further there are
          plots which give a lineage specific spread of the virus.
        </div>
      </el-col>
      
    </el-row>
    
    <transition name="fade">
      <div id="selection-panel" :style="`color: ${store.theme.viewMode.textColor[store.theme.viewMode.active]}; background-color: ${store.theme.viewMode.backgroundColor[store.theme.viewMode.active]}`">
        <el-row style="margin-top: 0.5em" v-if="store.render.HomeDateRangePicker">
          <el-col :xs="{span: 22, offset: 1}" :sm="{span: 22, offset: 1}" :md="{span: 20, offset: 1}" :lg="{span: 16, offset: 5}"
            >
            <div style="margin-left: 20px">
              <div style="margin-bottom: 0.2em; font-weight: bold">Pick date range</div>
              <div>
                <el-date-picker v-model="startDate" type="date" placeholder="Select date" style="margin-right: 10px" size="mini">
                </el-date-picker>
                to
                <el-date-picker v-model="endDate" type="date" placeholder="Select date" style="margin: 0px 10px" size="mini">
                </el-date-picker>
              </div>      
            </div>
          </el-col>
        </el-row>

        <el-row style="margin-top: 0.5em; padding-bottom: 0.4em" v-if="store.render.HomePangolinLineageSelect">
          <el-col :xs="{span: 22, offset: 1}" :sm="{span: 22, offset: 1}" :md="{span: 20, offset: 1}" :lg="{span: 16, offset: 5}"
            >
              <div style="margin-left: 20px">
                <div style="margin-bottom: 0.2em; font-weight: bold">Select pangolin lineages</div>
                <el-select v-if="store.render.SituationPangolinLineageSelect" id="pango-search-select" size="mini" style="width: 80%;"
                  v-model="store.datasets.selectedPangolinLineages" multiple filterable remote reserve-keyword placeholder="Pango Lineage Search"
                  :remote-method="pangoLineageSearch" :loading="searchLoading" @change="pangoLineageSelection" >
                  <el-option v-for="item in pangoLineageSelectOptions" :key="item.value" :label="item.label" :value="item.value" size="mini">
                  </el-option>
                </el-select>
              </div>
          </el-col>
        </el-row>
      </div>
    </transition>

    <transition name="fade">
      <el-row style="text-align: justify; margin-top: 3em" v-if="store.render.HomeRecentGenomesStateDistribution">
        <el-col style="background-color: rgba(230, 230, 235, 0.8); border-radius: 3px; padding: 20px" :xs="{span: 22, offset: 1}" :sm="{span: 22, offset: 1}" :md="{span: 20, offset: 1}" :lg="{span: 16, offset: 5}">
          <div class="page-header" style="text-align: center; font-size: 1.5em; padding: 0px; margin-bottom: 2em">State-wise distribution</div>
          <recent-genomes-state-distribution height="50vh" :key="startDate+endDate" :startDate="modStartDate" :endDate="modEndDate" v-if="plots[0]"></recent-genomes-state-distribution>
        </el-col>
      </el-row>
    </transition>

    <transition name="fade">
      <el-row style="text-align: justify; margin-top: 3em" v-if="store.render.HomeRecentGenomesSampleDemographics">
        <el-col style="background-color: rgba(255, 240, 240, 0.7); border-radius: 3px; padding: 20px" :xs="{span: 22, offset: 1}" :sm="{span: 22, offset: 1}" :md="{span: 20, offset: 1}" :lg="{span: 16, offset: 5}">
          <el-row>
            <div class="page-header" style="text-align: center; font-size: 1.5em; padding: 0px; margin-bottom: 1em">Sample demographics</div>
            <el-col :xs="{span: 22, offset: 1}" :sm="{span: 22, offset: 1}" :md="{span: 20, offset: 1}" :lg="{span: 16, offset: 5}">
              <recent-genomes-sample-demographics :height="'40vh'" :key="startDate+endDate" :startDate="modStartDate" :endDate="modEndDate"></recent-genomes-sample-demographics>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </transition>

    <transition name="fade">
      <el-row v-if="store.render.HomeCladeDistributionTimeline" style="margin-top: 3em;">
        <el-col style="background-color: rgba(230, 230, 235, 0.8); border-radius: 3px; padding: 20px" :xs="{span: 22, offset: 1}" :sm="{span: 22, offset: 1}" :md="{span: 20, offset: 1}" :lg="{span: 16, offset: 5}">
          <el-row style="padding: 0px 30px">
            <div class="page-header" style="text-align: center; font-size: 1.5em; padding: 0px">Clade distribution timeline</div>
            <el-col class="section-content text" :xs="{span: 24, offset: 0}" :sm="{span: 24, offset: 0}" :md="{span: 24, offset: 0}" :lg="{span: 24, offset: 0}"
              style="margin-top: 20px">
              Based on the prominent mutations common to a group of genomes, viruses are grouped into different lineages.
              <!-- <a href="https://nextstrain.org/" style="color: #4e4e4e">Nextstrain</a> team proposed a compatible nomenclature  -->
              <!-- to accommodate the year wise changes in clades.  -->
              The area chart represents the temporal change in proportions of 
              prevalant lineages of SARs-CoV-2 averaged over a window of one week. Useful to observe the decline or rise of 
              a particular lineage. Lineage names are based on  
              <a href="https://cov-lineages.org/" style="color: #4e4e4e">Pango Classification</a>. By default the plot
              only shows data for top 10 lineages by frequency in selected date range.
            </el-col>

            <el-col class="section-content plot" :xs="{span: 24, offset: 0}" :sm="{span: 24, offset: 0}" :md="{span: 24, offset: 0}" :lg="{span: 24, offset: 0}"
              style="margin-top: 20px">
              <genome-clade-timeline :startDate="modStartDate" :endDate="modEndDate" :lineages="store.datasets.selectedPangolinLineages" :key="startDate+endDate+store.datasets.selectedPangolinLineages.join('')+store.events.trigger"></genome-clade-timeline>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </transition>

    <transition name="fade">
      <el-row style="text-align: justify; margin-top: 3em" v-if="store.render.HomeRecentGenomesVOCStats">
        <el-col :xs="{span: 22, offset: 1}" :sm="{span: 22, offset: 1}" :md="{span: 20, offset: 1}" :lg="{span: 16, offset: 5}">
          <div class="page-header" :style="`text-align: center; font-size: 1.5em; color: ${store.theme.viewMode.textColor[store.theme.viewMode.active]}`">Month-wise numbers of VoCs across India</div>
          <recent-genomes-voc-stats height="50vh" :key="startDate+endDate+store.datasets.selectedPangolinLineages.join('')+store.events.trigger" :startDate="modStartDate" :endDate="modEndDate" :lineages="store.datasets.selectedPangolinLineages" ></recent-genomes-voc-stats>
        </el-col>
      </el-row>
    </transition>


    <el-row style="text-align: justify; margin-top: 3em">
      <el-col style="background-color: rgba(237, 245, 255, 0.7); border-radius: 3px; padding: 20px" :xs="{span: 22, offset: 1}" :sm="{span: 22, offset: 1}" :md="{span: 20, offset: 1}" :lg="{span: 16, offset: 5}">
        <div class="page-header" style="text-align: center; font-size: 1.5em ">Temporal changes in major circulating lineages</div>
        <voc-timeline height="60vh" :key="startDate+endDate+store.datasets.selectedPangolinLineages.join('')+store.events.trigger" :startDate="modStartDate" :endDate="modEndDate" :lineages="store.datasets.selectedPangolinLineages" ></voc-timeline>
      </el-col>
    </el-row>

    <el-row style="text-align: justify; margin-top: 20px">
      <el-col style="background-color: rgba(255, 240, 240, 0.7); border-radius: 3px" :xs="{span: 22, offset: 1}" :sm="{span: 22, offset: 1}" :md="{span: 20, offset: 1}" :lg="{span: 16, offset: 5}">
          <div class="page-header" style="text-align: center; font-size: 1.5em; padding: 30px 0px 0px 0px; margin-bottom: 1em">Geographical distribution of major circulating lineages</div>
        <el-row>
          <el-col :sm="{span: 12}" :xs="{span: 24}" v-for="variant in store.datasets.selectedPangolinLineages" :key="variant" style="margin-top: 20px">
            <geomap-timeline height="50vh" :variant="variant" :index="1" :key="startDate+endDate" :dataStartDate="modStartDate" :dataEndDate="modEndDate" v-if="plots[3]" ></geomap-timeline>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    
  </div>
</template>

<script>
import { store } from '@/scripts/store.js'
import PostService from '@/scripts/post_service.js'
import debounce from 'lodash/debounce'

const _ = require('lodash')

export default {
  name: 'Home',
  components: {
    SideIcons:      () => import('@/components/SideIcons.vue'),
    MainStatistics: () => import('@/components/MainStatistics.vue'),
    SampleDemographics: () => import('@/components/plots/SampleDemographics.vue'),
    ImportantVariantsTimeline: () => import('@/components/plots/ImportantVariantsTimeline.vue'),
    GenomeCladeTimeline: () => import('@/components/GenomeCladeTimeline.vue'),
    TimelineEvents: () => import('@/components/TimelineEvents.vue'),
    RecentGenomesStateDistribution: () => import('@/components/situation/RecentGenomesStateDistribution.vue'),
    RecentGenomesSampleDemographics: () => import('@/components/situation/RecentGenomesSampleDemographics.vue'),
    VariantCountryGeoMap: () => import('@/components/plots/VariantCountryGeoMap.vue'),
    
    SituationCladeTimeline: () => import('@/components/SituationCladeTimeline.vue'),
    RecentGenomesVocStats: () => import('@/components/situation/RecentGenomesVOCStats.vue'),
    VocTimeline:    () => import('@/components/situation/VOCTimeline.vue'),
    GeomapTimeline: () => import('@/components/situation/GeomapTimeline.vue'),
  },
  created () {
  },
  data() {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0')
    let mm = String(today.getMonth() + 1).padStart(2, '0')
    let yyyy = today.getFullYear()

    today = `${yyyy}-${mm}-${dd}`

    return {
      store: store,
      showHelpContent: false,
      searchLoading: false,
      topPangolinLineages: [],
      pangolinLineages: [],
      pangoLineageSelectOptions: [],
      startDate: Date.parse("2021-01-01"),
      endDate: Date.parse(today),
      plots: {
        0:false, 1:false, 2:false, 3:false
      },
      class_opts: [
        {label: "Nexstrain lineage", value: "nextstrain_clade"}, 
        {label: "Pangolin lineage", value: "pangolin_lineage"}
      ],
    }
  },
  computed:{
    modStartDate() {
      const context = this
      const date = new Date(this.startDate)
      let month = date.getMonth() + 1
      month = (month < 10) ? `0${month}` : month
      let day = date.getDate()
      day = (day < 10) ? `0${day}` : day
      Object.keys(context.plots).forEach((p, i) => {
        context.plots[i] = false
        setTimeout(() => {
          context.plots[i] = true
        }, 500 + i*500)
      })
      return `${date.getFullYear()}-${month}-${day}`
    },
    modEndDate() {
      const context = this
      const date = new Date(this.endDate)
      let month = date.getUTCMonth() + 1
      month = (month < 10) ? `0${month}` : month
      let day = date.getUTCDate() + 1
      day = (day < 10) ? `0${day}` : day
      Object.keys(context.plots).forEach((p, i) => {
        context.plots[i] = false
        setTimeout(() => {
          context.plots[i] = true
        }, 500 + i*500)
      })
      return `${date.getFullYear()}-${month}-${day}`
    },
    dateBoxY() {
      const dateBox = document.getElementById('home-date-range-picker')
      if (dateBox !== null) {
        const dateBoxRect = dateBox.getBoundingClientRect()
        return dateBoxRect.top
      }
      else {
        return undefined
      }
    },
    selectBoxY() {
      const selectBox = document.getElementById('selection-panel')
      if (selectBox !== null) {
        const selectBoxRect = selectBox.getBoundingClientRect()
        return selectBoxRect.top
      }
      else {
        return undefined
      }
    }

  },
  async mounted() {
    const context = this
    window.addEventListener('scroll', context.handleScroll)

    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();

    today = `${yyyy}-${mm}-${dd}`

    const topPangolinLineages = await PostService.getSituationData({
      plot: "topPangolinLineages",
      startDate: "2020-10-01",
      endDate: today
    })
    context.topPangolinLineages = _.map(topPangolinLineages, 'pangolin_lineage')
    context.pangolinLineages = context.topPangolinLineages
    store.datasets.selectedPangolinLineages = context.topPangolinLineages
    
    for (let l in store.datasets.selectedPangolinLineages) {
      const lineage = store.datasets.selectedPangolinLineages[l]
      store.theme.colors.pangolin_lineages[lineage] = store.theme.colors.palettes.lineage_colors[l%(store.theme.colors.palettes.lineage_colors.length)]
    }
  },
  methods: {
    loadHomePage() {
      store.methods.loadHomePage()
    },

    handleScroll(event) {
      const selectBox = document.getElementById('selection-panel')
      if (selectBox !== null) {
        if (window.scrollY >= this.selectBoxY + 100) {
          selectBox.classList.add('selection-top-fixed')
        }
        else {
          selectBox.classList.remove('selection-top-fixed')
        }
      }
    },

    redirectPage: function (path) {
      this.$router.push(path)
    },
    
    pangoLineageSearch(query) {
      if (query !== '') {
        this.searchLoading = true;
        setTimeout(() => {
          this.searchLoading = false;
          this.pangoLineageSelectOptions = _.map(store.constants.pangolinLineages.filter(item => {
            return item.toLowerCase()
              .indexOf(query.toLowerCase()) > -1;
          }), d => { return { label: d, value: d } });
        }, 200);
      } else {
        this.pangoLineageSelectOptions = [];
      }
    },

    async pangoLineageSelection(val) {
      const context = this

      let drop_lineages = []
      for (let lineage in store.theme.colors.pangolin_lineages) {
        if (val.indexOf(lineage) === -1) {
          drop_lineages.push(lineage)
        }
      }

      let existing_colors = Object.values(store.theme.colors.pangolin_lineages)
      for (let v in val) {
        const lineage = val[v]
        if (!(lineage in store.theme.colors.pangolin_lineages)) {
          let color_index = (store.datasets.selectedPangolinLineages.length) % 24
          let color = store.theme.colors.palettes.lineage_colors[color_index]
          let color_eindex = existing_colors.indexOf(color)
          let limit = (existing_colors.length > 24) ? (existing_colors.length - 24) : 24
          while (color_eindex !== -1 && color_eindex < limit) {
            color_index = (color_index + 1) % 24
            color = store.theme.colors.palettes.lineage_colors[color_index]
            color_eindex = existing_colors.indexOf(color)
            limit = (existing_colors.length > 24) ? (existing_colors.length - 24) : 24
          }
          store.theme.colors.pangolin_lineages[lineage] = color
        }
      }
      
      for (let l in drop_lineages) {
        delete store.theme.colors.pangolin_lineages[drop_lineages[l]]
      }
      
      const  query = 'pangolinFrequencyTimeline&lineage[]='+ val.join('&lineage[]=')
      context.cladeFrequencyData = await PostService.getPlotData(query)
      context.updateCladeFrequencyTimeline += 1
    }
  },
  destroyed() {
    console.log('Homepage destroyed!')
    // store.render.methods.destroyHomepage()
  }
}
</script>

<style>
.selection-top-fixed {
  position: fixed;
  z-index: 10;
  top: 0;
  width: 100vw;
  padding: 5px;
  /* background-color: #ffffff; */
  margin-top: 0px !important;
}


.page-header {
  font-family: 'Hammersmith One', sans-serif;
  font-size: 2em;
}

.click-link {
  text-decoration: none;
  padding: 3px 5px;
  border-radius: 3px;
  background-color: rgba(150, 155, 155, 0.6);
  font-size: 0.8em; 
  font-weight: bold;
}

.home-card-popover {
  font-family: 'Oxygen', Arial, Helvetica, sans-serif;
  text-align: justify;
  max-width: 300px;
  word-break: unset;
}

.section-header {
  font-family: 'Hammersmith One', sans-serif;
  font-size: 2em;
  color: #434343;
  padding: 20px;
  padding-left: 40px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.intro-text {
  font-family: 'Oxygen', Arial, Helvetica, sans-serif;
  font-weight: bold;
  color: #4e4e4e;
  border-radius: 3px;
  background-color: rgba(210, 210, 210, 0.6);
  padding: 20px;
}

.section-content.text {
  font-family: 'Oxygen', Arial, Helvetica, sans-serif;
  font-size: 0.9em;
  font-weight: bold;
  color: #4e4e4e;
  padding: 0px 10px;
}
</style>
